export enum TipoFluxoEnum {
  PADRAO,
  ERRO,
  PESQUISA
}
